import React from "react";
import PolicyGrid from "../customer-policy-grid/CustomerPolicyGrid"; 
import { PolicyCoverageReadDto } from "../../../model/PolicyCoverageReadDto";
import { CustomerPolicyDetailLabels as cstPolicyCoverageLabel } from '../../../../shared/util/label';
import { Cell, Column } from "react-table";
import { formatWithCommas, fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { PolicySummaryErrorMessages } from "../../../../shared/util/constant";
import { PolicyFloodCoverageDto } from "../../../model/PolicyFloodCoverageDto";

export interface ICustomerPolicyFloodCoverage {
  policyFloodCoverage: PolicyFloodCoverageDto[];
}

const CustomerPolicyFloodCoverage: React.FunctionComponent<ICustomerPolicyFloodCoverage> = (props) => {
  const columns: any[] = [
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_BUILDINGLIMIT1,
      accessor: "buildingLimit1",
      Cell: row => <div><span title={row.value}>{formatWithCommas(row.value)}</span></div>,
      width: 160,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_BUILDINGPREMIUM,
      accessor: "buildingPremium",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_CONTENTLIMIT1,
      accessor: "contentLimit1",
      Cell: row => <div><span title={row.value}>{formatWithCommas(row.value)}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_CONTENTPREMIUM,
      accessor: "contentPremium",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_ADDITIONALCOVERAGETOTAL,
      accessor: "additionalCoverageTotal",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 240,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_DISCOUNTSURCHARGESTOTAL,
      accessor: "discountSurchargesTotal",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 240,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_PREPAIDTOTAL,
      accessor: "prePaidTotal",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.FLOOD_COVERAGE_ANNUALTOTAL,
      accessor: "annualTotal",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    }
  ];

  return (
    <PolicyGrid
      data={props.policyFloodCoverage}
      columns={columns}
      gridId="policyFloodCoverageGrid"
      disableSorting = {true}
      //sortDefault={[{ id: "coverageCode", asc: true }]}
      noRecordsMessage= {PolicySummaryErrorMessages.NO_COVERAGE_FOUND}
    />
  );
};

export default CustomerPolicyFloodCoverage;
